import { ZonedDateTime, ZoneId } from '@js-joda/core';
import React from 'react';
import {
  TrainingPlanDetailsFragment,
  useUpdateTrainingPlanMutation,
} from '../../../graphql/types';
import { EventCategories } from '../../../utils/trackingEvents';
import { ButtonVariant } from '../../reusable/Button';
import {
  ConfirmationModal,
  ConfirmationModalProps,
} from '../../reusable/ConfirmationModal';

interface ConfirmArchivePlanProps {
  isOpen: ConfirmationModalProps['isOpen'];
  onClose: ConfirmationModalProps['onClose'];
  onConfirm: ConfirmationModalProps['onConfirm'];
  trainingPlan: TrainingPlanDetailsFragment;
}
const ConfirmArchivePlan: React.FC<ConfirmArchivePlanProps> = ({
  isOpen,
  onClose,
  onConfirm,

  trainingPlan,
}) => {
  const [archiveTrainingPlan, { loading }] = useUpdateTrainingPlanMutation();
  const handleConfirm = async () => {
    await archiveTrainingPlan({
      variables: {
        input: {
          id: trainingPlan.id,
          archivedAt: ZonedDateTime.now(ZoneId.UTC).toString(),
        },
      },
    });
    onConfirm();
  };
  const description = `You are archiving ${trainingPlan.name}. This is not reversible.`;
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title="Are you sure you want to archive this plan?"
      confirmButtonVariant={ButtonVariant.Danger}
      cancelLabel="Nevermind"
      confirmLabel="Archive Plan"
      confirmationDisabled={loading}
      description={description}
      trackingData={{
        event_category: EventCategories.TrainingPlans,
        plan_id: trainingPlan.id,
      }}
    />
  );
};

export default ConfirmArchivePlan;
